import { render, staticRenderFns } from "./CardAddress.vue?vue&type=template&id=6855e3b8&scoped=true&"
import script from "./CardAddress.vue?vue&type=script&lang=js&"
export * from "./CardAddress.vue?vue&type=script&lang=js&"
import style0 from "./CardAddress.vue?vue&type=style&index=0&id=6855e3b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6855e3b8",
  null
  
)

export default component.exports